import App from './App.ce.vue';
import { applyPolyfills, defineCustomElements as defineWorkbenchCustomElements } from '@workbench/core/dist/loader';
import { createApp, defineCustomElement } from 'vue';
import { createWcWrapper } from './utils/wc-wrapper.util';
import { createI18nService } from './utils/i18n';
import { getAemEnvironmentVariables } from './utils/aem.util';
import { initAssetServer } from './__webpack_public_path__';
import { ConfigService } from './utils/config-service';

const {
  config: { marketAvailability },
} = require('../oneweb.js');

initAssetServer();

applyPolyfills().then(() => {
  defineWorkbenchCustomElements(window);
});

const isAvailableForMarket = (language: string, country: string): boolean => {
  if (!marketAvailability || !Array.isArray(marketAvailability) || !marketAvailability.length) return false;

  return marketAvailability.some(
    (market: { language?: string; country?: string }) =>
      market?.language === language && market?.country?.toLowerCase() === country.toLowerCase(),
  );
};

// eslint-disable-next-line vue/require-name-property
const app = createApp({});
getAemEnvironmentVariables()
  .then(async ({ language, country, assetUri }) => {
    if (!isAvailableForMarket(language, country)) {
      console.warn(`Region picker is not available for market ${language}-${country}, skipping initialisation`);
      return;
    }
    const config = await ConfigService.fetchConfig(country.toLowerCase(), assetUri, 'emh-region-picker');
    const locale = `${language}-${country.toUpperCase()}`;
    await createI18nService(locale, app);
    const WrappedCustomComponent = createWcWrapper(App, app, config);
    const CustomElement = defineCustomElement(WrappedCustomComponent);

    try {
      window.customElements.define('dh-io-emh-region-picker', CustomElement);
    } catch (err) {
      console.log(err);
    }
  })
  .catch((error: any) => {
    console.error('Error while initialising Region Picker', error);
  });
